"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "responseData", {
    enumerable: true,
    get: function() {
        return responseData;
    }
});
const responseData = {
    data: {
        appBlanket: {},
        name: null,
        color: null,
        enterpriseColorId: null,
        shouldColorBeUsedAsPageBackground: false,
        icon: null,
        description: null,
        isRevisionHistoryEnabled: false,
        sortTiebreakerKey: 'appeaC4x3aMV9DtKf',
        defaultViewMutability: null,
        maintenanceModeSettings: null,
        sharesById: {
            shrY6swT2FOy9X1Bl: {
                id: 'shrY6swT2FOy9X1Bl',
                modelId: 'apprb2mFeIlQitU0o',
                createdByUserId: 'usr9GWEED0hhrQ3P7',
                canBeCloned: true,
                canBeExported: true,
                includeHiddenColumns: false,
                includeBlocks: true,
                emailDomain: null,
                hasPassword: false,
                generationNumber: 0,
                metadata: null
            }
        },
        workflowSectionsById: {},
        workflowTriggerConnectionsById: {},
        applicationTransactionNumber: 4,
        tableSchemas: [
            {
                id: 'tblcUCwSqLZGRu7FG',
                name: 'Film',
                primaryColumnId: 'fld6r7a0q9hodzUgY',
                columns: [
                    {
                        id: 'fld6r7a0q9hodzUgY',
                        name: 'Name',
                        type: 'text',
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fld6IgZRozMKeFyc5',
                        name: 'Notes',
                        type: 'multilineText',
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldqMqzYMQ7i85g5O',
                        name: 'Attachments',
                        type: 'multipleAttachment',
                        typeOptions: {
                            unreversed: true
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldlEkObSXpshw2wk',
                        name: 'Status',
                        type: 'select',
                        typeOptions: {
                            choices: {
                                selB88mIG48gDkyyi: {
                                    id: 'selB88mIG48gDkyyi',
                                    name: 'Todo',
                                    color: 'red'
                                },
                                selLdfWbEZbfEieY1: {
                                    id: 'selLdfWbEZbfEieY1',
                                    name: 'In progress',
                                    color: 'yellow'
                                },
                                selkIsEUrlTxcnMUB: {
                                    id: 'selkIsEUrlTxcnMUB',
                                    name: 'Done',
                                    color: 'green'
                                }
                            },
                            choiceOrder: [
                                'selB88mIG48gDkyyi',
                                'selLdfWbEZbfEieY1',
                                'selkIsEUrlTxcnMUB'
                            ]
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldSx61dqgUzHTn1l',
                        name: 'Done',
                        type: 'checkbox',
                        typeOptions: {
                            color: 'green',
                            icon: 'check'
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldH7RPO1Ik2ienk7',
                        name: 'Tags',
                        type: 'multiSelect',
                        typeOptions: {
                            choiceOrder: [
                                'selaJa1G5A3GDBYe1',
                                'selBdTMOIeHQWDzJo',
                                'selfI1gYUGdHPpxn8',
                                'sel4AqJn6lj1NBbzz',
                                'selQeCSXh62SW1hTc',
                                'selTFILiTsyI8Jfn0',
                                'selBGm0lj7h96rM9L',
                                'selSD99a6a2xEb83x',
                                'sellFaDt7It7KMvAL',
                                'selYusIsmYi4Z7UzS',
                                'selARkRtFX7vRFlya',
                                'selAwfYRRsKMug7Fv'
                            ],
                            choices: {
                                selaJa1G5A3GDBYe1: {
                                    id: 'selaJa1G5A3GDBYe1',
                                    color: 'blue',
                                    name: 'Jan'
                                },
                                selBdTMOIeHQWDzJo: {
                                    id: 'selBdTMOIeHQWDzJo',
                                    color: 'cyan',
                                    name: 'Feb'
                                },
                                selfI1gYUGdHPpxn8: {
                                    id: 'selfI1gYUGdHPpxn8',
                                    color: 'teal',
                                    name: 'Mar'
                                },
                                sel4AqJn6lj1NBbzz: {
                                    id: 'sel4AqJn6lj1NBbzz',
                                    color: 'green',
                                    name: 'Apr'
                                },
                                selQeCSXh62SW1hTc: {
                                    id: 'selQeCSXh62SW1hTc',
                                    color: 'yellow',
                                    name: 'May'
                                },
                                selTFILiTsyI8Jfn0: {
                                    id: 'selTFILiTsyI8Jfn0',
                                    color: 'orange',
                                    name: 'Jun'
                                },
                                selBGm0lj7h96rM9L: {
                                    id: 'selBGm0lj7h96rM9L',
                                    color: 'red',
                                    name: 'Jul'
                                },
                                selSD99a6a2xEb83x: {
                                    id: 'selSD99a6a2xEb83x',
                                    color: 'pink',
                                    name: 'Aug'
                                },
                                sellFaDt7It7KMvAL: {
                                    id: 'sellFaDt7It7KMvAL',
                                    color: 'purple',
                                    name: 'Sep'
                                },
                                selYusIsmYi4Z7UzS: {
                                    id: 'selYusIsmYi4Z7UzS',
                                    color: 'gray',
                                    name: 'Oct'
                                },
                                selARkRtFX7vRFlya: {
                                    id: 'selARkRtFX7vRFlya',
                                    color: 'blue',
                                    name: 'Nov'
                                },
                                selAwfYRRsKMug7Fv: {
                                    id: 'selAwfYRRsKMug7Fv',
                                    color: 'cyan',
                                    name: 'Dec'
                                }
                            },
                            disableColors: false
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldqSMGqzoIKvexVL',
                        name: 'Date',
                        type: 'date',
                        typeOptions: {
                            isDateTime: false,
                            dateFormat: 'Local'
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldC1wGc9klzZw8nE',
                        name: 'Phone',
                        type: 'phone',
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldpGVOU1gA9CZUP9',
                        name: 'Email',
                        type: 'text',
                        typeOptions: {
                            validatorName: 'email'
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldg6nJJBJAxGnb8m',
                        name: 'URL',
                        type: 'text',
                        typeOptions: {
                            validatorName: 'url'
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldBvDdsV1k24yKDu',
                        name: 'Number',
                        type: 'number',
                        typeOptions: {
                            format: 'decimal',
                            precision: 1,
                            negative: false,
                            validatorName: 'positive'
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fld2cA23dqfpiQ37p',
                        name: 'Value',
                        type: 'number',
                        typeOptions: {
                            format: 'currency',
                            precision: 2,
                            symbol: '$',
                            negative: false,
                            validatorName: 'positive'
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldlebEyEK11MAXqP',
                        name: 'Percent',
                        type: 'number',
                        typeOptions: {
                            format: 'percentV2',
                            precision: 0,
                            negative: false,
                            validatorName: 'positive'
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fld62jI4iMGIWBuAH',
                        name: 'Duration',
                        type: 'number',
                        typeOptions: {
                            format: 'duration',
                            durationFormat: 'h:mm',
                            negative: true
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldwMZogQefTVfwfT',
                        name: 'Rating',
                        type: 'rating',
                        typeOptions: {
                            color: 'yellow',
                            icon: 'star',
                            max: 5
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldmVzyNoFUOktFba',
                        name: 'Calculation',
                        type: 'formula',
                        typeOptions: {
                            formulaTextParsed: 'SUM(column_value_fldBvDdsV1k24yKDu, column_value_fld2cA23dqfpiQ37p, column_value_fldlebEyEK11MAXqP, column_value_fld62jI4iMGIWBuAH) * 100 / 25',
                            dependencies: {
                                referencedColumnIdsForValue: [
                                    'fldBvDdsV1k24yKDu',
                                    'fld2cA23dqfpiQ37p',
                                    'fldlebEyEK11MAXqP',
                                    'fld62jI4iMGIWBuAH'
                                ],
                                referencedFormulaFunctions: [
                                    'SUM',
                                    'multiply',
                                    'divide'
                                ],
                                dependsOnCurrentRow: true
                            },
                            resultType: 'number',
                            resultIsArray: false
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldoQ9fOkIU5Mhrtp',
                        name: 'Actor',
                        type: 'foreignKey',
                        typeOptions: {
                            foreignTableId: 'tblRGcmllRGzkz5p6',
                            relationship: 'many',
                            unreversed: true,
                            symmetricColumnId: 'fldrqN5ajLiEwNy0t'
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldBAkWGWoEQaM5uK',
                        name: 'Status (from Actor)',
                        type: 'lookup',
                        typeOptions: {
                            relationColumnId: 'fldoQ9fOkIU5Mhrtp',
                            foreignTableRollupColumnId: 'fldXxq8VN0UhMy1xR',
                            canUseSelectResultType: true,
                            choices: {
                                selo9oxLEpJnKvdCw: {
                                    id: 'selo9oxLEpJnKvdCw',
                                    name: 'Todo',
                                    color: 'red'
                                },
                                selo0u9rf3ESDiEGC: {
                                    id: 'selo0u9rf3ESDiEGC',
                                    name: 'In progress',
                                    color: 'yellow'
                                },
                                selDkYEL82PbLt73w: {
                                    id: 'selDkYEL82PbLt73w',
                                    name: 'Done',
                                    color: 'green'
                                }
                            },
                            choiceOrder: [
                                'selo9oxLEpJnKvdCw',
                                'selo0u9rf3ESDiEGC',
                                'selDkYEL82PbLt73w'
                            ],
                            dependencies: {
                                referencedColumnIdsForValue: [
                                    'fldoQ9fOkIU5Mhrtp',
                                    'fldXxq8VN0UhMy1xR'
                                ]
                            },
                            resultType: 'select',
                            resultIsArray: true
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldrUlRlnWNRHa5Wn',
                        name: 'Status Rollup (from Actor)',
                        type: 'rollup',
                        typeOptions: {
                            relationColumnId: 'fldoQ9fOkIU5Mhrtp',
                            foreignTableRollupColumnId: 'flduxFfvDassOS6sm',
                            formulaTextParsed: 'COUNTALL(values)',
                            dependencies: {
                                referencedColumnIdsForValue: [
                                    'fldoQ9fOkIU5Mhrtp',
                                    'flduxFfvDassOS6sm'
                                ],
                                referencedFormulaFunctions: [
                                    'COUNTALL'
                                ],
                                dependsOnCurrentRow: true
                            },
                            resultType: 'number',
                            resultIsArray: false
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    }
                ],
                meaningfulColumnOrder: [
                    {
                        columnId: 'fld6r7a0q9hodzUgY',
                        visibility: true
                    },
                    {
                        columnId: 'fld6IgZRozMKeFyc5',
                        visibility: true
                    },
                    {
                        columnId: 'fldqMqzYMQ7i85g5O',
                        visibility: false
                    },
                    {
                        columnId: 'fldlEkObSXpshw2wk',
                        visibility: true
                    },
                    {
                        columnId: 'fldH7RPO1Ik2ienk7',
                        visibility: true,
                        width: 180
                    },
                    {
                        columnId: 'fldSx61dqgUzHTn1l',
                        visibility: true
                    },
                    {
                        columnId: 'fldqSMGqzoIKvexVL',
                        visibility: true
                    },
                    {
                        columnId: 'fldC1wGc9klzZw8nE',
                        visibility: true
                    },
                    {
                        columnId: 'fldpGVOU1gA9CZUP9',
                        visibility: true
                    },
                    {
                        columnId: 'fldg6nJJBJAxGnb8m',
                        visibility: true
                    },
                    {
                        columnId: 'fldBvDdsV1k24yKDu',
                        visibility: true,
                        width: 168
                    },
                    {
                        columnId: 'fld2cA23dqfpiQ37p',
                        visibility: true
                    },
                    {
                        columnId: 'fldlebEyEK11MAXqP',
                        visibility: true
                    },
                    {
                        columnId: 'fld62jI4iMGIWBuAH',
                        visibility: true
                    },
                    {
                        columnId: 'fldwMZogQefTVfwfT',
                        visibility: true
                    },
                    {
                        columnId: 'fldmVzyNoFUOktFba',
                        visibility: true
                    },
                    {
                        columnId: 'fldoQ9fOkIU5Mhrtp',
                        visibility: true,
                        width: 252
                    },
                    {
                        columnId: 'fldBAkWGWoEQaM5uK',
                        visibility: true
                    },
                    {
                        columnId: 'fldrUlRlnWNRHa5Wn',
                        visibility: true
                    }
                ],
                views: [
                    {
                        id: 'viwebeyBYaiCnNwwO',
                        name: 'Grid view',
                        type: 'grid',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'viwXfVqIcM25FVTbd',
                        name: 'FormTitle',
                        type: 'form',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    }
                ],
                viewOrder: [
                    'viwebeyBYaiCnNwwO',
                    'viwXfVqIcM25FVTbd'
                ],
                viewsById: {
                    viwebeyBYaiCnNwwO: {
                        id: 'viwebeyBYaiCnNwwO',
                        name: 'Grid view',
                        type: 'grid',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    viwXfVqIcM25FVTbd: {
                        id: 'viwXfVqIcM25FVTbd',
                        name: 'FormTitle',
                        type: 'form',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    }
                },
                viewSectionsById: {},
                rowTemplatesById: {},
                schemaChecksum: '7a0236dd572ca6eea33ffac2438b88b2ab8b5ec390fc1b326b686b59ca87ab93',
                dateDependencySettings: null,
                rowUnit: null,
                isHiddenFromSwitcher: false,
                columnSetById: {}
            },
            {
                id: 'tblRGcmllRGzkz5p6',
                name: 'Actor',
                primaryColumnId: 'flduxFfvDassOS6sm',
                columns: [
                    {
                        id: 'flduxFfvDassOS6sm',
                        name: 'Name',
                        type: 'text',
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldBPTD14QIXSNarb',
                        name: 'Notes',
                        type: 'multilineText',
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldn3XBgPr3SEbsXv',
                        name: 'Attachments',
                        type: 'multipleAttachment',
                        typeOptions: {
                            unreversed: true
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldXxq8VN0UhMy1xR',
                        name: 'Status',
                        type: 'select',
                        typeOptions: {
                            choices: {
                                selo9oxLEpJnKvdCw: {
                                    id: 'selo9oxLEpJnKvdCw',
                                    name: 'Todo',
                                    color: 'red'
                                },
                                selo0u9rf3ESDiEGC: {
                                    id: 'selo0u9rf3ESDiEGC',
                                    name: 'In progress',
                                    color: 'yellow'
                                },
                                selDkYEL82PbLt73w: {
                                    id: 'selDkYEL82PbLt73w',
                                    name: 'Done',
                                    color: 'green'
                                }
                            },
                            choiceOrder: [
                                'selo9oxLEpJnKvdCw',
                                'selo0u9rf3ESDiEGC',
                                'selDkYEL82PbLt73w'
                            ]
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldrqN5ajLiEwNy0t',
                        name: 'Film',
                        type: 'foreignKey',
                        typeOptions: {
                            foreignTableId: 'tblcUCwSqLZGRu7FG',
                            symmetricColumnId: 'fldoQ9fOkIU5Mhrtp',
                            relationship: 'many',
                            unreversed: true
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    }
                ],
                meaningfulColumnOrder: [
                    {
                        columnId: 'flduxFfvDassOS6sm',
                        visibility: true
                    },
                    {
                        columnId: 'fldBPTD14QIXSNarb',
                        visibility: true
                    },
                    {
                        columnId: 'fldn3XBgPr3SEbsXv',
                        visibility: true
                    },
                    {
                        columnId: 'fldXxq8VN0UhMy1xR',
                        visibility: true
                    },
                    {
                        columnId: 'fldrqN5ajLiEwNy0t',
                        visibility: true
                    }
                ],
                views: [
                    {
                        id: 'viwqB059qatxSF8tI',
                        name: 'Grid view',
                        type: 'grid',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'viw8p8zWYmN4Kwine',
                        name: 'Filter&Sort',
                        type: 'grid',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    }
                ],
                viewOrder: [
                    'viwqB059qatxSF8tI',
                    'viw8p8zWYmN4Kwine'
                ],
                viewsById: {
                    viwqB059qatxSF8tI: {
                        id: 'viwqB059qatxSF8tI',
                        name: 'Grid view',
                        type: 'grid',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    viw8p8zWYmN4Kwine: {
                        id: 'viw8p8zWYmN4Kwine',
                        name: 'Filter&Sort',
                        type: 'grid',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    }
                },
                viewSectionsById: {},
                rowTemplatesById: {},
                schemaChecksum: '4eb8ace8331d3127315b918b96cbe4494ef891826c88e22ce9cbbcf46834f8a7',
                dateDependencySettings: null,
                rowUnit: null,
                isHiddenFromSwitcher: false,
                columnSetById: {}
            },
            {
                id: 'tblp9k6RJTAAEeoRy',
                name: 'Producer',
                primaryColumnId: 'fldaKGmXYDqycI6FP',
                columns: [
                    {
                        id: 'fldaKGmXYDqycI6FP',
                        name: 'Name',
                        type: 'text',
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldJ4MZo6XbVBK8Cm',
                        name: 'Notes',
                        type: 'multilineText',
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldeuBlvCNuVLTpag',
                        name: 'Attachments',
                        type: 'multipleAttachment',
                        typeOptions: {
                            unreversed: true
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'fldi3aP7nI5d7Th0S',
                        name: 'Status',
                        type: 'select',
                        typeOptions: {
                            choices: {
                                selWtsuJeVBHLHGoQ: {
                                    id: 'selWtsuJeVBHLHGoQ',
                                    name: 'Todo',
                                    color: 'red'
                                },
                                selI41dgnSlWTTkr4: {
                                    id: 'selI41dgnSlWTTkr4',
                                    name: 'In progress',
                                    color: 'yellow'
                                },
                                selSsal85SEQEX4x9: {
                                    id: 'selSsal85SEQEX4x9',
                                    name: 'Done',
                                    color: 'green'
                                }
                            },
                            choiceOrder: [
                                'selWtsuJeVBHLHGoQ',
                                'selI41dgnSlWTTkr4',
                                'selSsal85SEQEX4x9'
                            ]
                        },
                        initialCreatedByUserId: 'usr9GWEED0hhrQ3P7'
                    }
                ],
                meaningfulColumnOrder: [
                    {
                        columnId: 'fldaKGmXYDqycI6FP',
                        visibility: true
                    },
                    {
                        columnId: 'fldJ4MZo6XbVBK8Cm',
                        visibility: true
                    },
                    {
                        columnId: 'fldeuBlvCNuVLTpag',
                        visibility: false
                    },
                    {
                        columnId: 'fldi3aP7nI5d7Th0S',
                        visibility: true
                    }
                ],
                views: [
                    {
                        id: 'viw5f7BhLA3OkthNv',
                        name: 'Grid view',
                        type: 'grid',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'viwRRK2UljiQB3kko',
                        name: 'Grid 2',
                        type: 'grid',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'viwsF12Zep2IrUQ4L',
                        name: 'Grid 3',
                        type: 'grid',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'viw9HVTL3HmZ3NCDd',
                        name: 'Grid 4',
                        type: 'grid',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'viwMKGcEPNkD797BF',
                        name: 'Form',
                        type: 'form',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'viwc6YeYMlRUFJUYa',
                        name: 'Form 2',
                        type: 'form',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'viwWYcqdMbeOx3Eg3',
                        name: 'Form 3',
                        type: 'form',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'viwZnwvKkOBnDqpul',
                        name: 'Form 4',
                        type: 'form',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'viw8Xse051lREItSC',
                        name: 'Gallery',
                        type: 'gallery',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'viwvu6dBtJcPFvl4b',
                        name: 'Gallery 2',
                        type: 'gallery',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    {
                        id: 'viwWiQnKWgbL2TGLw',
                        name: 'Gallery 3',
                        type: 'gallery',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    }
                ],
                viewOrder: [
                    'viw5f7BhLA3OkthNv',
                    'viwRRK2UljiQB3kko',
                    'viwsF12Zep2IrUQ4L',
                    'viw9HVTL3HmZ3NCDd',
                    'viwMKGcEPNkD797BF',
                    'viwc6YeYMlRUFJUYa',
                    'viwWYcqdMbeOx3Eg3',
                    'viwZnwvKkOBnDqpul',
                    'viw8Xse051lREItSC',
                    'viwvu6dBtJcPFvl4b',
                    'viwWiQnKWgbL2TGLw'
                ],
                viewsById: {
                    viw5f7BhLA3OkthNv: {
                        id: 'viw5f7BhLA3OkthNv',
                        name: 'Grid view',
                        type: 'grid',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    viwRRK2UljiQB3kko: {
                        id: 'viwRRK2UljiQB3kko',
                        name: 'Grid 2',
                        type: 'grid',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    viwsF12Zep2IrUQ4L: {
                        id: 'viwsF12Zep2IrUQ4L',
                        name: 'Grid 3',
                        type: 'grid',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    viw9HVTL3HmZ3NCDd: {
                        id: 'viw9HVTL3HmZ3NCDd',
                        name: 'Grid 4',
                        type: 'grid',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    viwMKGcEPNkD797BF: {
                        id: 'viwMKGcEPNkD797BF',
                        name: 'Form',
                        type: 'form',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    viwc6YeYMlRUFJUYa: {
                        id: 'viwc6YeYMlRUFJUYa',
                        name: 'Form 2',
                        type: 'form',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    viwWYcqdMbeOx3Eg3: {
                        id: 'viwWYcqdMbeOx3Eg3',
                        name: 'Form 3',
                        type: 'form',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    viwZnwvKkOBnDqpul: {
                        id: 'viwZnwvKkOBnDqpul',
                        name: 'Form 4',
                        type: 'form',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    viw8Xse051lREItSC: {
                        id: 'viw8Xse051lREItSC',
                        name: 'Gallery',
                        type: 'gallery',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    viwvu6dBtJcPFvl4b: {
                        id: 'viwvu6dBtJcPFvl4b',
                        name: 'Gallery 2',
                        type: 'gallery',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    },
                    viwWiQnKWgbL2TGLw: {
                        id: 'viwWiQnKWgbL2TGLw',
                        name: 'Gallery 3',
                        type: 'gallery',
                        personalForUserId: null,
                        description: null,
                        createdByUserId: 'usr9GWEED0hhrQ3P7'
                    }
                },
                viewSectionsById: {},
                rowTemplatesById: {},
                schemaChecksum: 'dd6ae0e1f9763f0d67a6409e8ce35e67a7b978fa94b70134bae84bb1e35f5542',
                dateDependencySettings: null,
                rowUnit: null,
                isHiddenFromSwitcher: false,
                columnSetById: {}
            }
        ],
        hasBlockInstallations: false,
        packageInstallationsById: {},
        featureKitInstallationById: {},
        applicationAdminFlags: {
            UPDATE_PRIMITIVE_CELL_THROTTLE_MS: null,
            UPDATE_RICH_TEXT_CELL_THROTTLE_MS: null,
            MAX_WORKFLOWS_PER_APPLICATION: null,
            MAX_SYNC_SOURCES_PER_APPLICATION: null,
            MAX_SYNC_SOURCES_PER_TABLE: null,
            MAX_SYNCED_TABLES_PER_APPLICATION: null,
            CUSTOM_MAX_NUM_COLUMNS_PER_TABLE: null,
            CUSTOM_MAX_NUM_ROWS_PER_TABLE: null,
            DENYLISTED_PAGE_BUNDLES_FOR_PAGE_BUNDLE_COLLABORATORS: null,
            MAX_ROW_TEMPLATES_PER_APPLICATION: null,
            APPLICATION_AI_AUTOMATIC_GENERATION_RECORD_COUNT_LIMIT: null,
            APPLICATION_AI_BULK_GENERATION_RECORD_COUNT_LIMIT: null,
            WORKFLOW_FIND_RECORDS_MAX_LIMIT: null,
            WORKFLOW_EXECUTION_READ_WORKFLOW_ACTION_EXECUTION_BATCH_SIZE: null,
            APPLICATION_AI_QA_IFRAME_URL: null,
            AUTO_REFRESH_TIMEOUT_MS: null,
            ENABLE_PRODUCT_CENTRAL: null,
            APPLICATION_DEPENDENCY_GRAPH_THROTTLE_MS: null
        },
        pageLayoutSchemaVersion: 26,
        pageSections: [],
        pageBundles: [],
        unparentedPageMetadata: [],
        canUserModifyAllUnparentedPages: false,
        portal: null,
        isCurrentUserPortalPageBundleCollaborator: false,
        uploadedUserContentCdnSetting: {
            applicationScopedAuthMode: 'private'
        },
        applicationV2TargetedFeatureFlagClientConfiguration: {
            dateSparklineDisplay: {
                trafficLevel: 0
            },
            blockModelBridgeLongWaitUntilReadyBeforeWriteTimeout: {
                trafficLevel: 0
            },
            aiFieldMatching: {
                trafficLevel: 100
            },
            aiAutomaticFieldMatching: {
                trafficLevel: 0
            },
            applicationChangeHookCreateSyncHooksWithSpecificationPayloadEnabled: {
                trafficLevel: 100
            },
            externalTableSyncSkipRealTimeSyncForSyncWithFieldTypeCustomizationToLinkedRecord: {
                trafficLevel: 100
            },
            externalTableSyncRealTimeSyncAllowSchemaUpdatesFromResolution: {
                trafficLevel: 100
            },
            syncLinkedRecordsCellUpdateOptimization: {
                trafficLevel: 100
            },
            canCreateRelationFieldsSourcedByCollaboratorField: {
                trafficLevel: 0
            },
            enableExternalTableSyncInfoManagerForAuthoritativeSourceWrites: {
                trafficLevel: 0
            },
            externalTableSyncThreadedEnqueue: {
                trafficLevel: 100
            },
            attachmentsAuthV3ShouldUseSignedAuthV5Urls: {
                trafficLevel: 0
            },
            attachmentsAuthV3: {
                trafficLevel: 0
            },
            eudrAttachmentBoundaryCrossings: {
                trafficLevel: 0
            },
            externalTableSyncPingSourceBasesFromTarget: {
                trafficLevel: 100
            },
            changeHooksOnUelLogActions: {
                trafficLevel: 0
            },
            performChangeHookProcessingOnUelPath: {
                trafficLevel: 100
            },
            applicationSearchMultiTokenBooleanSearch: {
                trafficLevel: 100
            },
            applicationSearchMultiTokenBooleanSearchAllowFuzziness: {
                trafficLevel: 0
            },
            twoWaySyncServerSideTransparentEditingNonBlocking: {
                trafficLevel: 100
            },
            twoWaySyncCreateDelete: {
                trafficLevel: 100
            },
            twoWaySyncPricingGating: {
                trafficLevel: 100
            },
            enforceMaxSourceCellCountForEnablingTwoWaySync: {
                precalculatedVariant: {
                    variant: 'control',
                    reason: 'disabled'
                }
            },
            externalTableSyncQuerySchemaInIncrementalSync: {
                trafficLevel: 100
            },
            revisionHistoryErrorLogging: {
                trafficLevel: 0
            },
            workflowsSlackShowPermalinkInExpressionBuilder: {
                trafficLevel: 0
            },
            workflowsFindRecordsUserDefinedLimits: {
                trafficLevel: 0
            },
            dateDependenciesRevisionHistory: {
                trafficLevel: 100
            },
            disableUsageInsightsOneYearOption: {
                precalculatedVariant: {
                    variant: 'control',
                    reason: 'disabled'
                }
            },
            tableDeleteOrphanCascadeForApplication: {
                trafficLevel: 0
            },
            disabledWorkflowOnSchemaChangeSuggestion: {
                trafficLevel: 100
            },
            syncFailureSuggestion: {
                trafficLevel: 100
            },
            unusedViewsSuggestion: {
                trafficLevel: 100
            },
            unusedSelectChoicesSuggestion: {
                trafficLevel: 0
            },
            unifiedEventLog: {
                trafficLevel: 100
            },
            unifiedEventLogPublishingBlockDbCommits: {
                trafficLevel: 100
            },
            projectReadDataForRowCards: {
                trafficLevel: 0
            },
            threadSafeStoreUseLargerMapSize: {
                trafficLevel: 0
            },
            clientSideProfilingForApplication: {
                trafficLevel: 0
            },
            modelNamePreserveWhitespace: {
                trafficLevel: 100
            }
        },
        applicationV2FeatureFlagClientContext: {
            applicationId: 'apprb2mFeIlQitU0o',
            flagNameToPrecalculatedVariant: {
                dateSparklineDisplay: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                blockModelBridgeLongWaitUntilReadyBeforeWriteTimeout: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiFieldMatching: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAutomaticFieldMatching: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                applicationChangeHookCreateSyncHooksWithSpecificationPayloadEnabled: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                externalTableSyncSkipRealTimeSyncForSyncWithFieldTypeCustomizationToLinkedRecord: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                externalTableSyncRealTimeSyncAllowSchemaUpdatesFromResolution: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                syncLinkedRecordsCellUpdateOptimization: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                canCreateRelationFieldsSourcedByCollaboratorField: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                enableExternalTableSyncInfoManagerForAuthoritativeSourceWrites: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                externalTableSyncThreadedEnqueue: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                attachmentsAuthV3ShouldUseSignedAuthV5Urls: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                attachmentsAuthV3: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                eudrAttachmentBoundaryCrossings: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                externalTableSyncPingSourceBasesFromTarget: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                changeHooksOnUelLogActions: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                performChangeHookProcessingOnUelPath: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                applicationSearchMultiTokenBooleanSearch: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                applicationSearchMultiTokenBooleanSearchAllowFuzziness: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                twoWaySyncServerSideTransparentEditingNonBlocking: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                twoWaySyncCreateDelete: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                twoWaySyncPricingGating: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                enforceMaxSourceCellCountForEnablingTwoWaySync: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                },
                externalTableSyncQuerySchemaInIncrementalSync: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                revisionHistoryErrorLogging: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                workflowsSlackShowPermalinkInExpressionBuilder: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                workflowsFindRecordsUserDefinedLimits: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                dateDependenciesRevisionHistory: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                disableUsageInsightsOneYearOption: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                },
                tableDeleteOrphanCascadeForApplication: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                disabledWorkflowOnSchemaChangeSuggestion: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                syncFailureSuggestion: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                unusedViewsSuggestion: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                unusedSelectChoicesSuggestion: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                unifiedEventLog: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                unifiedEventLogPublishingBlockDbCommits: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                projectReadDataForRowCards: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                threadSafeStoreUseLargerMapSize: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                clientSideProfilingForApplication: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                modelNamePreserveWhitespace: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationV2',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                }
            }
        },
        applicationV2EnabledFeatureNames: [
            'aiFieldMatching',
            'applicationChangeHookCreateSyncHooksWithSpecificationPayloadEnabled',
            'externalTableSyncSkipRealTimeSyncForSyncWithFieldTypeCustomizationToLinkedRecord',
            'externalTableSyncRealTimeSyncAllowSchemaUpdatesFromResolution',
            'syncLinkedRecordsCellUpdateOptimization',
            'externalTableSyncThreadedEnqueue',
            'externalTableSyncPingSourceBasesFromTarget',
            'performChangeHookProcessingOnUelPath',
            'applicationSearchMultiTokenBooleanSearch',
            'twoWaySyncServerSideTransparentEditingNonBlocking',
            'twoWaySyncCreateDelete',
            'twoWaySyncPricingGating',
            'externalTableSyncQuerySchemaInIncrementalSync',
            'dateDependenciesRevisionHistory',
            'disabledWorkflowOnSchemaChangeSuggestion',
            'syncFailureSuggestion',
            'unusedViewsSuggestion',
            'unifiedEventLog',
            'unifiedEventLogPublishingBlockDbCommits',
            'modelNamePreserveWhitespace'
        ],
        applicationUnifiedFeatureFlagClientContext: {
            applicationId: 'apprb2mFeIlQitU0o',
            flagNameToPrecalculatedVariant: {
                iCalSharedViewBestEffortAllDayColumn: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                enforceHipaaComplianceCheckInIsAiEnabledForEnterpriseAsync: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                },
                restrictPagesDataToAllEntryPagesAndReachableRowPagesInPageBundleForMobileClient: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                logUnexpectedQueryAuthorizationPageError: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                timelineShowExactStartTimeWithoutEndColumn: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                timelineViewGanttCriticalPath: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                interfaceDesignerCustomFormFieldValidation: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                interfaceChartMultipleSeries: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                interfaceChartDualYAxes: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                interfaceDesignerIncreaseNumberOfLegendItemsForTopBottom: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                interfaceDesignerSupersizeRecordDetailPage: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                standaloneFormSection: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                standaloneFormReordering: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                enableDocExtractionInAutomations: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                interfaceDesignerGalleryAdvancedOptions: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                interfaceDesignerGalleryExpandTruncatedProperties: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                cardsWidgetForDashboards: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                productCentralApplicationOverride: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                forceSolutionThemeForBase: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                allowRenamingSolution: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                interfaceDesignerDisableRuntimeOutputLiveMemo: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiEnableStreamingForCobuilder: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiPlayInterfaceLaunch: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAppBuildingDocExtractionInBaseCreationModal: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                customElementCodeGenStreaming: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiCoverImageGenerationForStandaloneFormsApplicationScoped: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                cobuilderCustomizationAnthropicByDefault: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                },
                cobuilderCustomizationGetOrderedModelListForCustomizationPromptOverridesVariant: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                cobuilderCustomizationWorkflowIteration: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniUnifiedAgent: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiAssistantCreateTableWithAi: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantRecordsEditabilityForPBC: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantAttachmentsForPBC: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantGPT41: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiAssistantUseShortenedHyperIds: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantGetSchemaTool: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantRespectReadUntrustedData: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantReturnApplicationHasPublicWriteAccess: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantConsiderSyncedDataSourcesAsPubliclyWritable: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantOptimizeQueriesWithinTable: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantEnableQuerySkippingForMatchingFilters: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantOptimizeQueries: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantExampleDataForPagesClientSideMode: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantMakeSingleGetContextForAgentRequest: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantGridArtifactStreaming: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiAssistantAdvisors: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiSpikeOmniAppDescriptions: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniReportGeneration: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniReportGenerationAdvancedFeatures: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniReportGenerationFeatureAwarenessCard: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniUseGpt5ForRecords: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                omniUseOpusV4P5ForQa: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniUseVercelForOpenAi: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniUseVercelForAnthropicBedrock: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniUseVercelForGemini: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantMessagePdfExport: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiAssistantGridArtifactLiveBaseData: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantShouldFallBackThroughDynamicModels: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                enableAiChatsManagementKillSwitch: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                },
                aiFieldAgentInBaseSupport: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantWebDataRetrieval: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiServerQaAgent: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiServerWebChatOwnershipCheck: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiServerAgentPersistEventsToDynamo: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                omniSupport: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniInterfaceLongTextEditor: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniRecordScopedContext: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniCellContextMenuAskOmni: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniRecordScopedContextRollout: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantAppendStreaming: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniContextualSearchEntryPoint: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniRecordAgentMarkdownSupport: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                omniRecordAgentFineGrainedToolStreaming: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                disableEditingOfEditableSharedViews: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                linkedRecordPickerMultiSelectInRecordDetail: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                cascadingEndUserFilters: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                computedFieldDynamicFiltersInForms: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                packagePlatformVerboseLogging: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                packagesPlatformSendRealtimeLikePayloadAfterReleaseCreated: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                packagesPlatformDisableCustomizingLevelsPageElement: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                packagesPlatformDisableCustomizingQueryContainerFilters: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                packagesPlatformAllowCustomizingQueryContainerEndUserActions: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                packagesPlatformAllowCustomizingQueryContainerEndUserFilters: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                packagesPlatformAllowCustomizingInboxPageElement: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                connectSingleApplicationRealtimeWebSocketToAppAirtableCom: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                },
                interfaceExtensionsAllowOnPubliclySharedInterfacePages: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                interfaceExtensionsHideTopBarOnPubliclySharedInterfacePages: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                interfaceExtensionsAllowBlockInstallationInQueryContainerPageElement: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                interfaceExtensionsEnableEditability: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                interfaceExtensionsEnableMultiTable: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                interfaceExtensionsEnableRevertToPreviousBlockVersionButtonInOmni: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                interfaceExtensionsEnableAiGeneration: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                interfaceExtensionsEnableDeltaEdits: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                interfaceExtensionsCodeGenToolRefactor: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                interfaceExtensionsEnableImagesAsContext: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                sandboxEligibleApplications: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxPreventUndestroy: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxCopyTestOuputToSandbox: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxSkipPageDestroyIfMissing: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                sandboxCommitSchemaValidationOnRead: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                sandboxCompactColumnOrder: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxSelectivePublishing: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxSelectivePublishingFormulaChaining: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxAttemptToAutoResolveColumnDependencyCycles: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxPackages: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxV1DataExtensions: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxV1InterfaceCustomExtensions: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxAllowAllFieldsToBeSyncedIfPartofPackage: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxGenerateActionSequenceApiWithDisplayInfo: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxOnlyAllowApplicationMetadataUpdatesFromProductionApplication: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxAllowDestroyingMainApplicationsWithoutDestroyingSandboxFirst: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxGenerateSignedActionSequence: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxGenerateStepsDueToSyncSourceChanges: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxRequireSignedActionSequence: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxSkipActionSequenceStalenessCheckForApplication: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                sandboxPreviewAsInactiveCollaborators: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                openAio1ModelAvailabilityUnified: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                openAiChatGpt5P2ModelAvailability: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                anthropicClaudeOpus4p5ModelAvailability: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                gemini3ProModelAvailability: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                gemini3FlashModelAvailability: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                openAiImageGenerationModelAvailability: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                openAiGptImage1P5ModelAvailabilityUnified: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                openAiGptImage1MiniModelAvailabilityUnified: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                gemini2P5FlashImageModelAvailabilityUnified: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                gemini3ProImageModelAvailabilityUnified: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                gemini3ProImageResolution: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiImageGenerationAutomation: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiImageGenerationAutomationBusinessEnterprise: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiImageGenerationFieldAgent: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiImageGenerationFieldAgentBusinessEnterprise: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                googleVeo3VideoGenerationModelAvailability: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiWebImageSearchSupport: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiWebContentGenerationFieldAgent: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiFieldAgentConfigV2: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiLinkedRecordFieldAgent: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiLinkedRecordFieldKeywordSearch: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiCreateLinkedRecordAiFieldsFromOmni: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiFieldAgentsLogToBraintrust: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiFieldAgentGenerationTriggers: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiReduceTaskQueueEmbeddingCrudRequestPriority: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiFieldMatchingUseLlmForAutomaticMatching: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiFieldMatchingAdvancedConfiguration: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiTextFieldMarkdownSupport: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAdoptionSuggestionsInFieldContextMenu: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAutomationsLibrary: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantCreateFieldAgentCommand: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiFieldMatchingInForms: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                displayChartArtifactInAiAssistant: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                saveChartToPage: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiEnableSemanticSearch: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiGenerateWorkflowActionOutputSchema: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantForBillingPlansThatIncludeAiSku: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiAssistantSupportAgent: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantLargeInputParallel: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantSuggestionGenerationV2: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantAllowBlankPageQueries: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantEnableCreditCharges: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiImageGenerationChargeAiCredits: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiImageGenerationHighInputFidelity: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                commandKRecordSearch: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiVectorSearchFilteringHeuristics: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                enableGoogleDriveToolsInFieldAgents: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                enableOneDriveToolsInFieldAgents: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                enableJiraToolsInFieldAgents: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                useLargeDocExtractionPipeline: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                useLargeDocExtractionPipelineInAutomation: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                letAiFieldReadExcelFiles: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                letAiFieldReadWebpImageFiles: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                letAiFieldReadImagesWithVisionModels: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                letAiFieldReadImagesWithVisionModelsBusinessEnterprise: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiTrimLargeApplicationSchemaInLlmPrompt: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                showOmniStopButton: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                allowEkmMilvusEmbeddingForInternalOnly: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                doubleWriteToMilvusAndLance: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                },
                writeNewEmbeddingConfigsToMilvus: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                readEmbeddingsFromMilvus: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                forceMilvusMigration: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiFinnhubAssistantAvailability: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiAssistantAirtableHelp: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiAssistantGenerateArtifactsForNonBaseData: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiAssistantVirtualTable: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiBedrockEmbeddings: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiEmbeddingsModelAutomaticCutover: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiEmbeddingConfigs: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantMultiAgentDelegationReal: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantRouterPlanning: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiAssistantRouterUserClarification: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                },
                aiAssistantBaseCollaboratorFullPermissionsInInterfaceView: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantScopedInInterfaceView: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantWithSyncInfo: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                aiAdoptionAiFieldCatalog: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantAnalyticsAvailability: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiAssistantAnalyticsFormatResponse: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiFreeGeneration: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowsExecuteActionsInThread: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowsEmailTrigger: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowsEmailTriggerAttachments: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowsEmailTriggerSkipTextToHtmlParsing: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowsNestedAdvancedLogic: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowsRepeatingGroupsInConditionals: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowsConditionalsInConditionals: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                isAutomationPerformanceStatsEnabled: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                workflowTriggerConnectionAvoidBaseMetadataApiCall: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowsCustomScriptsSetNodeMaxOldSpaceSize: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                workflowsDeployHistoryTab: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowsExperimentalFixForEmailInputLag: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                },
                workflowNodeExecutionPayloadsToS3: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowExecutionPayloadsToS3: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowExecutionReleaseLeaseDuringJobResuming: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowExecutionCheckAvailableLeasesBeforeScheduling: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowWebhookInvocationPayloadsToS3: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowReducerNodeSkipInputExpressionEvaluation: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                syncedLinkedRecordsSupportSelfLinkedRecords: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                levelsConfigAllowSyncedLinkedRecordColumns: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                externalTableSyncSyncLinkedRecordsColumnEditableForSourceWithSelectionCondition: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                reconnectSyncedLinkedRecordsColumnsWhenPossibleWhenRemovingSyncs: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                externalTableSyncFixMissingAuthoritativeColumn: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                externalTableSyncBatchOnNonEmptyCellsInCreatedRows: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                externalTableSyncBatchOnNumberOfComparedCells: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                externalTableSyncSkipDuplicateCreatedRows: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                externalTableSyncTimeOutUsingLastBatchStartTime: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                addExternalApiRequestBodyToDebugObj: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                disableSendToMsTeamsWorkflowActionOneOnOneMessaging: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                syncSetUmappedColumnsToDestroyedInFixers: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                },
                processExternalTableSyncsGetEnqueueContext: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                externalTableSyncFullTableDiffInThreadedEnqueue: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                attachmentProcessingTaskUseBatchedProcessingForExperimentalUploadTypes: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                fileUploaderModalContainFocus: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                attachmentVideoHackilyTryToPlayAlways: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                numberBadgeOnAllAnnotations: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                attachmentAltText: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                attachmentAltTextEditor: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                singleSelectApprovalsVisualVariant: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                atlassianJiraTrimFieldMetadata: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                jiraV3IssueSearchValidation: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                optimizeGetIssueMetadataForJiraCloud: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                applyJiraV3IssueSearchAPIForJiraCloud: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                azureDevOpsTwoWaySync: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                twoWaySyncIgnoreNoopArrayOperationsToSource: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                },
                workflowsSlackEnableThreadedMessageSupport: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                workflowsSlackChannelsDistributedCache: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                workflowsOutlookEventUseHtmlForDescriptionField: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                workflowSubscribers: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                dateDependenciesDisplayDateDependencyMetadataOutsideTimelineArrows: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                enableSharedApplicationOrBlockAppBlanketRedaction: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                unloadApplicationDataAndUnsubcribeFromRealtimeOnSetInactive: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                portalsShareTabApplicationScoped: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                coreDbInterfacesDemo: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                coreDbBtreeMvccCollection: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                coreDbShadowValidatePrivilegesPolicyConstruction: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                coreDbPrivilegesPolicyConstruction: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                measureRecalculatorDependenciesSerialization: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                constructUniquePathPageBundlePrivileges: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                shouldEnforcePrivilegesPolicyQueryAuthorizationTimingThreshold: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                shouldUseNewExpandedForeignRowPolicyModel: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                delayLastPageRuntimeDestroy: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                skipPreloadingQueriesDuringPageNavigation: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                useImportRowsShadowboxOpForPaste: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                skipPublishingUnparentedPagesWithNoChanges: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                interfacePermissionAvoidFullTableScanForLookupColumn: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                interfaceDesignerIncreasedMaxNumPagesPerPageBundle: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                interfaceDesignerEndUserHideEmptyParentsMultipleLevels: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                disableNewWorkflowTemplateInstalls: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                hideWorkflowTemplateSettings: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                truncateLongForeignKeyCellEditors: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                keepForeignKeyDropdownFilterResultsAcrossAfterPopoverClose: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                commentAttachments: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                commentsQA: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                redactSyncCellHistory: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                emitCellHistoryGroupingStats: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                disableSyncCellHistoryWrites: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                enforcePublicAPIBillingLimit: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                pageBundleInviteReminders: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                pageBundleInviteEmailRevamp2025: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                shareDialogSimplificationV3Base: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'winningVariant'
                    }
                },
                shareDialogSimplificationV4: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'winningVariant'
                    }
                },
                shareDialogSimplificationInterfaceEnterpriseRollout: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                implicitSorts: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                sendResponseDataWithOtRevisionForRowUpdateRichTextCellByApplyingOperation: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                singleApplicationRealtimeServerVerboseLogging: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                singleApplicationRealtimePopulateMultiThreadSubscriptionBuffer: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                singleApplicationRealtimeValidateMultiThreadSubscriptionBuffer: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                singleApplicationRealtimePromoteFromMultiThreadSubscriptionBuffer: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                singleApplicationRealtimeAsyncGetBroadcastablePushPayload: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                singleApplicationRealtimeEagerlyExpireSubscriptionsOnHeartbeat: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                singleApplicationRealtimeEagerlyExpireSubscriptionsOnClose: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                replicatedApplicationHandoff: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                replicatedApplicationHandoffFallbackToCoordinatedHandoff: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                replicatedCoreDbLoadingSidecar: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                enableReadQueriesMsgpackExperiment: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                enableRealtimeUpdatesPausingForReadQueries: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                coreDbSecondaryModeShadowValidationExperiment: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                coreDbSecondaryModeShadowValidationExperimentDisableTimeouts: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                useDispatchArchitecture: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                dispatchArchitectureServing: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                coreDbShadowboxDataMapperBatchWriteMode: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                logAllShadowboxOperationsPerformedInCrudRequestLogLine: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'ineligibleFromRule',
                        ruleType: 'enterpriseAccountIds'
                    }
                },
                memAppMutationSentinel: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                shouldEnablePreviewModeForViewsInApplication: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                shouldEnablePreviewModeForExperimentalViewTypesInApplication: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                backendSearchForPreviewMode: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                enableSearchHighlighting: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                previewModeThreshold: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'fiveThousand',
                        reason: 'winningVariant'
                    }
                },
                previewModeRowLimit: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'oneThousand',
                        reason: 'winningVariant'
                    }
                },
                foreignRowCustomDisplayNames: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                twoWaySyncCollaboratorField: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                featureKitsAllowSubstitutions: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                featureKitsEkmEncryptionForS3Data: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                searchAllVisibleColumnsInTableListRowsQuery: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                realTimeSyncTwoWaySyncPermissions: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                loadCellsByColumnInsteadOfByTable: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                realTimeSyncSourceTableLock: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                realTimeSyncEvaluateCellsWithNewSchema: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                solutionsCustomizations: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                feedbackSentimentChart: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                solutionsPromptAdditionalContext: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                realTimeSyncConvertSourceDiffToTargetDiffWithNewSchema: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                realTimeSyncChangeHookPayloadLengthCheckFix: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                googleCalendarSyncEnableEventTypeField: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                syncCollaboratorAttributionAsCollaboratorField: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                disableWorkflowExpressionBuilderDeepDive: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                workflowExpressionBuilderUseCache: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                workflowFanoutDecisionSkipLookupCellConversion: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                workflowCustomScriptRetryOnUserScriptTimeout: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                workflowExecutionLoadPayloadInBatch: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                workflowExecutionJobLockingDuringScheduling: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workflowExpressionEvaluationOnlyLoadBranchData: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                selfLinkedRecordBackLink: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                nestedSubtasksInLevelsView: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                enableCustomGridHeaderHeight: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                shouldShowDatasetsInLinkedRecordPicker: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                jiraSyncBypassTotal: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                includeColumnIsSyncedInPublicApi: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                coreDbFirstLoading: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                },
                coreDbFirstLoadingSidecar: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                allowEditOfManagedViewsLayoutInFeatureKit: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                enableCoreDbShadowboxMigrationWrapper: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                enableWritebackOfCellValuesToCoreDbOnColumnConfigChange: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                lazyLoadRowTemplateUserAccessStatusClient: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                lazyLoadRowTemplateUserAccessStatusServer: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                enableAiAssistantImportSpreadsheetTool: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                atlassianJiraAlwaysConstructSchemaFromGetFieldsEndpoint: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                editIndividualFieldPropertiesInManagedCurrencyField: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                snowflakeGetSqlQueryResultsAsStream: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                useRecordCardsForSmallerArtifacts: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                allowGiantGroupsApplicationScoped: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                enableOmniToDeleteWorkflows: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                hideOmniMoleInInterfaces: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                detailViewFocusScopeContain: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                enableCoreDbIsoTableDataCache: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                enableOmniAppCreationSharePromptPopover: {
                    targetedEntityId: 'apprb2mFeIlQitU0o',
                    targetedEntityType: 'applicationUnified',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                }
            }
        },
        rootBillingEntityFeatureFlagClientContext: {
            flagNameToPrecalculatedVariant: {
                enableEffectiveAiPolicyShadowEnforcement: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                gridAccessibilityImprovements: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                interfaceDesignerOmniButtonAction: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'winningVariant'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                aiFilterAssistance: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                omniConsultativeBuildingRootBillingEntityScoped: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                omniCellGridViewLongText: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                omniCellGridViewContextMenuAskOmniForMultipleRows: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                enableAiPolicyJournal: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                allowSubThreeYearDataRetention: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                allowApplicationMoveFromNonDataResidentToDataResidentRegion: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                adminPanelSyncConvertToForeignKeyColumns: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                aiCreditsForPortalAddOnCustomers: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                linkMandateConfirmationOnSubscriptionCreation: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                shadowModeStopDowngradeCredits: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                stopDowngradeCredits: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                trackSubscriptionStatus: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                enableCreditExpiration: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                enableShadowCreditExpiration: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                dataTableShouldEnableDataResidencyForS3Data: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                dataTablesSchemaManagement: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                enableCustomDomainInEnterpriseAdminPanelBasesTab: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                sendOrbBillingEvents: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                },
                enableExternalShareCollaboratorInviteRestriction: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'rootBillingEntity',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    },
                    decisionCacheKey: 'wspdknfrhBYeXd3GD'
                }
            }
        },
        workspaceFeatureFlagClientContext: {
            workspaceId: 'wspdknfrhBYeXd3GD',
            flagNameToPrecalculatedVariant: {
                omniChatSidebarResizing: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                sandboxAllowMoveMainAndSandboxApplicationsOutOfWorkspace: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                aiModerationParallelizationForOpenAiEnabled: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                },
                displayTaxIdComponents: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                billingRefactoredBusinessUpgradePaths: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                snapshotRestoreUnifiedEventLogEvents: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                snapshotRestoreUnifiedEventLogBlockDbCommits: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                enableHardRecordEnforcementServerSide: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                enableAttachmentLimitEnforcement: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                enableUpdatedOverLimitBadge: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                workspaceSettingsGracefullyHandleMissingApplicationOrPageBundle: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'trafficLevel'
                    }
                },
                workspaceInviteEmailRevamp2025: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                shareDialogSimplificationV3Workspace: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'winningVariant'
                    }
                },
                churnPreventionTeamPlanBillingCoupon2025Q4: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'random'
                    }
                },
                freeUserHighActivityDiscount: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'winningVariant'
                    }
                },
                highActivityOverL56dFreeWorkspaceBillingCoupon2025Q1: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                highActivityOverL56DFreeWorkspaceBillingCouponGa: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                nearOrAtLimitsFreeWorkspaceBillingCoupon2025Q1: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                checkoutAnnualFreeMonths: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'control',
                        reason: 'disabled'
                    }
                },
                deprecateHasMigratedToStripeDynamoDbCheck: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                },
                enableDecember2025TeamStarterPackPromotion: {
                    targetedEntityId: 'wspdknfrhBYeXd3GD',
                    targetedEntityType: 'workspace',
                    precalculatedVariant: {
                        variant: 'treatment',
                        reason: 'random'
                    }
                }
            }
        },
        hasApplicationEverInstalledSolutionsPackage: false,
        isUserLimitsHardEnforcementEnabledForParentWorkspace: false,
        ekmEnablementMetadata: {
            isEkmAttachmentUploadEnabled: false,
            isEkmEnabled: false,
            isFilestackFullyDisabled: true
        },
        syncedViewLimitMetadata: {
            maxSyncableSharedViews: 100,
            currentSyncableSharedViews: 0
        },
        aiConsumptionInfo: null,
        dataResidentRegion: null,
        assistantsById: {},
        hasUserSeenAntiPhishingWarningModalForApplication: false,
        areImplicitSortsEnabled: false,
        rowLimitPerViewOrPage: null,
        previewModeThreshold: null,
        customLoginPageProps: {
            signedLoginUserContentUrls: {}
        },
        emailWorkflowTriggerDomain: 'automations.airtableemail.com',
        isConstantPooledData: false
    }
};
